/**
 * Recorte da imagem do banner. Porta do cropImage.ts do Backoffice V2
 * (settings/customization), sem o React.
 *
 * Exporta em 2x do tamanho recomendado (407x151) para ficar nitido em tela
 * retina. WebP mantem transparencia e fica bem abaixo do limite de 2 MB;
 * navegador sem WebP no canvas devolve PNG, e o nome acompanha.
 */
export const BANNER_CROP = { width: 814, height: 302 };

export const shouldCrop = (file) => !!file && file.type !== 'image/svg+xml';

export const croppedFileName = (name, mime) => {
  const base = String(name || '').replace(/\.[^.]+$/, '') || 'banner';
  return base + (mime === 'image/webp' ? '.webp' : '.png');
};

const loadImage = (src) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = () => reject(new Error('invalid-image'));
  image.src = src;
});

/** `coordinates` em pixels da imagem original: { left, top, width, height }. */
export const cropToFile = (src, coordinates, fileName) =>
  loadImage(src).then((image) => new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    canvas.width = BANNER_CROP.width;
    canvas.height = BANNER_CROP.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) { reject(new Error('canvas-unavailable')); return; }
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, coordinates.left, coordinates.top, coordinates.width, coordinates.height,
      0, 0, BANNER_CROP.width, BANNER_CROP.height);
    canvas.toBlob((blob) => {
      if (!blob) { reject(new Error('canvas-to-blob-failed')); return; }
      const mime = blob.type === 'image/webp' ? 'image/webp' : 'image/png';
      resolve(new File([blob], croppedFileName(fileName, mime), { type: mime }));
    }, 'image/webp', 0.9);
  }));



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/bannerCrop.js